module.exports = __webpack_public_path__ + "img/IND-B-1-IV.20d9cad6.png";